import { render, staticRenderFns } from "./EmailBatchDisplay.vue?vue&type=template&id=28b70ee8&scoped=true&"
import script from "./EmailBatchDisplay.vue?vue&type=script&lang=js&"
export * from "./EmailBatchDisplay.vue?vue&type=script&lang=js&"
import style0 from "./EmailBatchDisplay.vue?vue&type=style&index=0&id=28b70ee8&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "28b70ee8",
  null
  
)

export default component.exports